<template>
  <clinician-app-layout>
    <template #header>
      <inertia-link
        :href="route('admin.learning-courses.index')"
        class="lg:absolute relative p-3 md:left-5 flex items-center text-vice-teal-500 text-xs"
      >
        <ChevronLeftIcon class="w-4 h-4 mr-1" />
        <span class="flex-none">All Courses</span>
      </inertia-link>
      <div
        class="pb-5 max-w-6xl mx-auto border-gray-200 sm:flex sm:items-center sm:justify-between"
      >
        <h2 class="text-3xl text-vice-teal-900 font-semibold leading-tight">Course</h2>

        <!-- Course Actions -->
        <div class="mt-3 space-x-3 flex sm:mt-0 sm:ml-4">
          <inertia-link
            :href="route('admin.learning-courses.edit', course.id)"
            class="
              py-2
              px-3
              text-xs
              rounded-md
              border border-gray-300
              text-gray-700
              hover:bg-gray-100
            "
          >
            Edit
          </inertia-link>
          <button
            data-cy="delete-draft"
            type="button"
            @click="destroyWarning = true"
            class="
              ml-3
              inline-flex
              items-center
              justify-center
              px-4
              py-2
              border border-vice-red
              rounded-md
              text-gray-700
              bg-white
              hover:bg-vice-rose-100
              focus:outline-none
              focus:ring-2 focus:ring-offset-2 focus:ring-gray-500
              sm:text-sm
            "
          >
            Delete course
          </button>
          <a
            v-if="course.slug"
            :href="route('course.showLearningCourse', course.slug)"
            target="_blank"
            class="py-2 px-3 bg-vice-teal-600 hover:bg-vice-teal-700 text-white text-xs rounded-md"
          >
            Launch course
          </a>
        </div>
      </div>
    </template>

    <!-- Body (make more attractive) -->
    <div class="max-w-6xl mx-auto sm:px-6 lg:px-8 py-8">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div class="md:col-span-2 space-y-8">
          <!-- Course Details Card -->
          <div class="bg-white border shadow overflow-hidden sm:rounded-lg">
            <!-- Header-->
            <div class="px-4 py-5 sm:px-6 flex justify-between items-center bg-light-grey border-b">
              <h3 class="text-lg leading-6 font-semibold text-vice-teal-700">
                General Information
              </h3>
              <span
                class="
                  px-3
                  py-1
                  uppercase
                  inline-flex
                  text-xs
                  leading-6
                  font-bold
                  rounded-full
                  shadow-sm
                "
                :class="badgeClass(course.status)"
              >
                {{ course.status }}
              </span>
            </div>

            <!-- Body -->
            <div class="border-t border-gray-100 px-4 py-5 sm:p-0">
              <dl class="sm:divide-y sm:divide-gray-100">
                <!-- Title -->
                <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 font-medium">
                  <dt class="text-sm text-gray-500">Title</dt>
                  <dd class="mt-1 text-sm text-mono text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ course.title }}
                  </dd>
                </div>

                <!-- Slug -->
                <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-medium text-gray-500">Link</dt>
                  <dd class="mt-1 text-sm text-mono text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ course.slug }}
                  </dd>
                </div>

                <!-- University -->
                <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-medium text-gray-500">Link</dt>
                  <dd class="mt-1 text-sm text-mono text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ course.university.name }}
                  </dd>
                </div>

                <!-- Delivery type -->
                <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-medium text-gray-500">Delivery type</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ deliveryType(course.delivery_type) }}
                  </dd>
                </div>

                <!-- <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">-->
                <!--   <dt class="text-sm font-medium text-gray-500">Enrolment open</dt>-->
                <!--   <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">-->
                <!--     <span-->
                <!--       v-if="course.enrolment_open"-->
                <!--       class="text-green-600 flex items-center font-medium"-->
                <!--     >-->
                <!--       <svg-->
                <!--         class="w-4 h-4 mr-1"-->
                <!--         fill="currentColor"-->
                <!--         viewBox="0 0 20 20"-->
                <!--         xmlns="http://www.w3.org/2000/svg"-->
                <!--       >-->
                <!--         <path-->
                <!--           fill-rule="evenodd"-->
                <!--           d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"-->
                <!--           clip-rule="evenodd"-->
                <!--         ></path>-->
                <!--       </svg>-->
                <!--       Yes-->
                <!--     </span>-->
                <!--     <span v-else class="text-gray-400 flex items-center">-->
                <!--       <svg-->
                <!--         class="w-4 h-4 mr-1"-->
                <!--         fill="currentColor"-->
                <!--         viewBox="0 0 20 20"-->
                <!--         xmlns="http://www.w3.org/2000/svg"-->
                <!--       >-->
                <!--         <path-->
                <!--           fill-rule="evenodd"-->
                <!--           d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"-->
                <!--           clip-rule="evenodd"-->
                <!--         ></path>-->
                <!--       </svg>-->
                <!--       No-->
                <!--     </span>-->
                <!--   </dd>-->
                <!-- </div>-->

                <!-- Scorm course -->
                <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-medium text-gray-500">Scorm course</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ course.scorm ? course.scorm.title : 'None' }}
                  </dd>
                </div>

                <!-- Live period -->
                <div
                  v-if="course.live_start_at || course.live_end_at"
                  class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">Live period</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span class="mr-2 text-gray-400">from</span>
                    <span class="font-semibold text-vice-teal-700">
                      {{ formatDateTime(course.live_start_at) }}
                    </span>
                    <span class="mx-2 text-gray-400">to</span>
                    <span class="font-semibold text-vice-teal-700">
                      {{ formatDateTime(course.live_end_at) }}
                    </span>
                  </dd>
                </div>

                <!-- About course -->
                <div
                  v-if="course.summary"
                  class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">About this course</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 whitespace-pre-line">
                    {{ course.summary }}
                  </dd>
                </div>

                <!-- Background -->
                <div
                  v-if="course.background"
                  class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">Background</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 whitespace-pre-line">
                    {{ course.background }}
                  </dd>
                </div>

                <!-- Learning outcomes -->
                <div
                  v-if="course.learning_outcomes"
                  class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">Learning outcomes</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 whitespace-pre-line">
                    <ul class="list-disc list-inside space-y-1">
                      <li v-for="outcome in course.learning_outcomes" :key="outcome.id">
                        {{ outcome }}
                      </li>
                    </ul>
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <!-- Sessions Card -->
          <div class="bg-white border shadow overflow-hidden sm:rounded-lg">
            <div class="p-4 pl-6 bg-light-grey border-b">
              <div
                v-tippy="{
                  content: course.clinicians.length === 0 ? 'Add clinician first' : '',
                  theme: 'light-border',
                  placement: 'bottom-end',
                  interactive: true,
                }"
                class="flex justify-between items-center"
              >
                <h3 class="text-lg leading-6 font-semibold text-vice-teal-700">Sessions</h3>
                <a
                  :href="
                    route('create.session', {
                      course_id: course.id,
                      university_id: course.university_id,
                    })
                  "
                  class="
                    py-2
                    px-3
                    bg-vice-teal-600
                    hover:bg-vice-teal-700
                    text-white text-xs
                    rounded-md
                  "
                  :class="{ 'opacity-50 pointer-events-none': course.clinicians.length === 0 }"
                >
                  Add Session
                </a>
              </div>
            </div>
            <div class="px-4 py-5 sm:px-6">
              <ul v-if="course.sessions && course.sessions.length" class="space-y-3">
                <li
                  v-for="s in course.sessions"
                  :key="s.id"
                  class="
                    flex
                    items-center
                    text-sm text-gray-700
                    bg-gray-50
                    p-3
                    rounded-md
                    border border-gray-100
                  "
                >
                  <svg
                    class="h-5 w-5 text-vice-teal-500 mr-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                    ></path>
                  </svg>
                  {{ s.title }}
                </li>
              </ul>
              <div v-else class="text-center py-6 text-gray-500 text-xs italic">
                No sessions scheduled.
              </div>
            </div>
          </div>
        </div>

        <!-- Clinicians and students cards -->
        <div class="space-y-8">
          <!-- Clinicians Card -->
          <div class="bg-white border shadow overflow-hidden sm:rounded-lg">
            <div class="px-4 py-6 sm:px-6 bg-light-grey border-b">
              <h3 class="text-md leading-6 font-semibold text-vice-teal-700 text-left">
                Clinicians
              </h3>
            </div>
            <div class="px-4 py-5 sm:px-6">
              <ul v-if="course.clinicians && course.clinicians.length" class="space-y-4">
                <li v-for="c in course.clinicians" :key="c.id" class="flex items-center space-x-3">
                  <div
                    class="
                      flex-shrink-0
                      h-10
                      w-10
                      rounded-full
                      bg-vice-teal-50
                      flex
                      items-center
                      justify-center
                      text-vice-teal-700
                      font-bold
                    "
                  >
                    {{ c.name.charAt(0) }}
                  </div>
                  <div class="text-sm font-medium text-gray-900">{{ c.name }}</div>
                </li>
              </ul>
              <div v-else class="text-center py-6 text-gray-500 italic">
                No clinicians assigned.
              </div>
            </div>
          </div>

          <!-- Students Card -->
          <div class="bg-white border shadow overflow-hidden sm:rounded-lg">
            <div class="px-4 py-6 sm:px-6 bg-light-grey border-b">
              <h3 class="text-md leading-6 font-semibold text-vice-teal-700 text-left">
                Students
                <span v-if="course.students">({{ course.students.length }})</span>
              </h3>
            </div>
            <div class="px-4 py-5 sm:px-6">
              <ul v-if="course.students && course.students.length" class="space-y-4">
                <li v-for="s in course.students" :key="s.id" class="flex items-center space-x-3">
                  <div
                    class="
                      flex-shrink-0
                      h-10
                      w-10
                      rounded-full
                      bg-vice-teal-50
                      flex
                      items-center
                      justify-center
                      text-vice-teal-700
                      font-bold
                    "
                  >
                    {{ s.name.charAt(0) }}
                  </div>
                  <div class="text-sm font-medium text-gray-900">{{ s.name }}</div>
                </li>
              </ul>
              <div v-else class="text-center py-6 text-gray-500 italic">No students assigned.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete course modal confirmation -->
    <TransitionRoot as="template" :show="destroyWarning">
      <Dialog
        as="div"
        class="fixed zoom-80 z-20 inset-0 overflow-y-auto"
        @close="destroyWarning = false"
      >
        <div
          class="
            flex
            items-end
            justify-center
            min-h-screen
            pt-4
            px-4
            pb-20
            text-center
            sm:block
            sm:p-0
          "
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              class="
                inline-block
                align-bottom
                bg-white
                rounded-lg
                px-4
                pt-5
                pb-4
                text-left
                overflow-hidden
                shadow-xl
                transform
                transition-all
                sm:my-8
                sm:align-middle
                sm:max-w-lg
                sm:w-full
                sm:p-6
              "
            >
              <div class="p-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Delete course</h3>
                <div class="mt-2 max-w-xl text-sm text-gray-500">
                  <p>You are about to remove this course. Confirm removing?</p>
                </div>
                <div class="mt-5">
                  <inertia-link
                    data-cy="delete-session-confirm"
                    @click="destroy"
                    method="post"
                    type="button"
                    class="
                      inline-flex
                      items-center
                      justify-center
                      px-4
                      py-2
                      border border-transparent
                      font-medium
                      rounded-md
                      text-red-700
                      bg-red-100
                      hover:bg-red-200
                      focus:outline-none
                      focus:ring-2 focus:ring-offset-2 focus:ring-red-500
                      sm:text-sm
                    "
                  >
                    Delete course
                  </inertia-link>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </clinician-app-layout>
</template>

<script>
import { ChevronLeftIcon } from '@heroicons/vue/solid';
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { ref } from 'vue';
import dayjs from 'dayjs';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
import { directive } from 'vue-tippy';
import ClinicianAppLayout from '@/Layouts/ClinicianAppLayout.vue';

export default {
  directives: {
    tippy: directive,
  },
  components: {
    DialogOverlay,
    TransitionChild,
    Dialog,
    TransitionRoot,
    ChevronLeftIcon,
    ClinicianAppLayout,
  },
  props: {
    course: Object,
  },
  data() {
    const destroyWarning = ref(false);
    return { destroyWarning };
  },
  methods: {
    destroy() {
      // Confirmation if needed
      this.$inertia.delete(route('admin.learning-courses.destroy', this.course.id));
    },
    deliveryType(type) {
      switch (type) {
        case 'on_demand':
          return 'On demand';
        default:
          return 'Live';
      }
    },
    badgeClass(status) {
      switch (status) {
        case 'published':
          return 'bg-green-100 text-green-800';
        case 'archived':
          return 'bg-gray-200 text-gray-700';
        default:
          return 'bg-vice-yellow text-vice-dark-yellow';
      }
    },
    formatDateTime(dateStr) {
      return dayjs(dateStr).format('DD MMMM YYYY');
    },
  },
};
</script>
